const safelyDecodeImageSource = (value) => {
  if (typeof value !== 'string') return '';
  try {
    return decodeURIComponent(value);
  } catch (error) {
    return value;
  }
};

const addLookupKey = (lookup, key, imageData) => {
  if (typeof key !== 'string') return;

  const trimmedKey = key.trim();
  if (!trimmedKey || lookup.has(trimmedKey)) return;

  lookup.set(trimmedKey, imageData);
};

const getImagePathCandidates = (value) => {
  if (typeof value !== 'string') return [];

  const candidates = new Set();
  const addCandidate = (candidate) => {
    if (typeof candidate !== 'string') return;

    const trimmedCandidate = candidate.trim();
    if (!trimmedCandidate) return;

    candidates.add(trimmedCandidate);

    const decodedCandidate = safelyDecodeImageSource(trimmedCandidate);
    if (decodedCandidate) {
      candidates.add(decodedCandidate);
    }
  };

  addCandidate(value);

  Array.from(candidates).forEach((candidate) => {
    const candidateWithoutHash = candidate.split('#')[0];
    const candidateWithoutQuery = candidateWithoutHash.split('?')[0];

    addCandidate(candidateWithoutQuery);

    try {
      const parsedUrl = new URL(candidateWithoutQuery, 'https://tornado.local');
      const { pathname } = parsedUrl;
      if (!pathname) return;

      addCandidate(pathname);
      addCandidate(pathname.replace(/^\//, ''));

      const pathSegments = pathname.split('/').filter(Boolean);
      addCandidate(pathSegments[pathSegments.length - 1]);
    } catch (error) {
      const slashlessValue = candidateWithoutQuery.replace(/^\//, '');
      addCandidate(slashlessValue);

      const pathSegments = slashlessValue.split('/').filter(Boolean);
      addCandidate(pathSegments[pathSegments.length - 1]);
    }
  });

  return Array.from(candidates);
};

export const getResponseImageSrc = (image) => {
  if (!image?.bytes_base64) return null;
  return `data:${image.mime_type || 'image/png'};base64,${image.bytes_base64}`;
};

export const getResponseImageAltText = (image, index) =>
  image?.description || image?.filename || `Generated image ${index + 1}`;

export const buildMarkdownImageLookup = (images) => {
  if (!Array.isArray(images) || !images.length) return null;

  const imageLookup = new Map();

  images.forEach((image, index) => {
    const imageSrc = getResponseImageSrc(image);
    if (!imageSrc) return;

    const imageData = {
      altText: getResponseImageAltText(image, index),
      src: imageSrc,
    };

    [image.filename, image.path, image.url, image.src].forEach((candidate) => {
      getImagePathCandidates(candidate).forEach((pathCandidate) => {
        addLookupKey(imageLookup, pathCandidate, imageData);
      });
    });
  });

  return imageLookup.size ? imageLookup : null;
};

export const resolveMarkdownImage = (source, imageSourceLookup) => {
  if (!source || !imageSourceLookup?.size) return null;

  const imageCandidates = getImagePathCandidates(source);
  for (const candidate of imageCandidates) {
    const matchedImage = imageSourceLookup.get(candidate);
    if (matchedImage) {
      return matchedImage;
    }
  }

  return null;
};
